module.exports = __webpack_public_path__ + "img/UNI_DM.0bb167be.png";